/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_CtaInputs */

const en_marketing_engagement_cta = /** @type {(inputs: Marketing_Engagement_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to JXD`)
};

const es_marketing_engagement_cta = /** @type {(inputs: Marketing_Engagement_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habla con JXD`)
};

const fr_marketing_engagement_cta = /** @type {(inputs: Marketing_Engagement_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parler à JXD`)
};

/**
* | output |
* | --- |
* | "Talk to JXD" |
*
* @param {Marketing_Engagement_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_cta = /** @type {((inputs?: Marketing_Engagement_CtaInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_CtaInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_cta(inputs)
	if (locale === "es") return es_marketing_engagement_cta(inputs)
	return fr_marketing_engagement_cta(inputs)
});